module.exports = __webpack_public_path__ + "static/img/1_0032.bc1c18f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0032.jpg
// module id = IT0N
// module chunks = 0